import React, { useState } from 'react'
import { AlertTitle, Button, CircularProgress, FormControl, InputLabel, MenuItem, Select, Snackbar } from '@mui/material';
import axios from "axios"
import { Auth } from "aws-amplify";
import MuiAlert from '@mui/material/Alert';
import { useTranslation } from 'react-i18next';

import FilterListIcon from '@mui/icons-material/FilterList';

import BarChart from '../../BarChart';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="standard" {...props} />;
});

const CompareReport = ({ superAdminInfo }) => {
  const [toastOpen, setToastOpen] = useState(false);
  const [toastType, setToastType] = useState([]);
  const [reportData, setReportData] = useState({})
  const [reportState, setReportState] = useState(false)
  const [compareState, setCompareState] = useState(true)
  const [reportError, setReportError] = useState("")
  const [testId, setTestId] = useState(["", ""])

  const [std, setStd] = useState("");
  const [lang, setLang] = useState("");
  const [region, setRegion] = useState("OVERALL");
  const [metric, setMetric] = useState("");

  const { t } = useTranslation();

  const handleToastClose = (event, reason) => {
    if (reason === 'clickaway') return
    setToastOpen(false);
  };

  const handleTestIdChange = (index, testId) => {
    setCompareState(true)
    setTestId(prev => prev.map((oldTestId, i) => {
      if(i===index) return testId
      else return oldTestId
    }));
  };

  const handleStdChange = (e) => {
    setStd(e.target.value);
  };

  const handleLangChange = (e) => {
    let lang = e.target.value
    if(reportData!=="" && (Object.keys(reportData[testId[0]].report.allRegions).includes(lang) || Object.keys(reportData[testId[1]].report.allRegions).includes(lang))){
      setLang(lang);
      let stds = [...new Set(reportData[testId[0]].report.allRegions[lang].map(item => item.std))].filter(item => 
                    [...new Set(reportData[testId[1]].report.allRegions[lang].map(item => item.std))].includes(item)
                  ).sort((a, b) => a - b)
      if(!stds.includes(std)) setStd(stds[0])
      let metrics = Object.keys(reportData["metric"][lang])
      if(!metrics.includes(metric)){
        setMetric(metrics[0])
        // setChartType(reportData["metric"][lang][metrics[0]][0])
      }
    }
    else if(reportData!==""){
      setReportError(t("superAdmin.results.compareTab.error_api_resultNotFoundLang"))
      setCompareState(true)
    }
  };

  const handleRegionChange = (e) => {
    setRegion(e.target.value);
  };

  const handleMetricChange = (e) => {
    // if(reportData!==""){
    //     let chartTypes = reportData["metric"][lang][e.target.value]
    //     if(!chartTypes.includes(chartType)) setChartType(chartTypes[0])
    // }
   setMetric(e.target.value);
  };

  var filteredReportData = ""
  if(lang && std!== "" && !compareState && (Object.keys(reportData[testId[0]].report.allRegions).includes(lang) || Object.keys(reportData[testId[1]].report.allRegions).includes(lang))) filteredReportData = {
    [testId[0]] : {
      "allRegions": reportData[testId[0]].report.allRegions[lang].filter(item => item.std === std),
      "thresholds": reportData[testId[0]].report.thresholds[lang].filter(item => item.std === std)[0]
    },
    [testId[1]] : {
      "allRegions": reportData[testId[1]].report.allRegions[lang].filter(item => item.std === std),
      "thresholds": reportData[testId[1]].report.thresholds[lang].filter(item => item.std === std)[0]
    }
  }

  const handleCompare = () => {

    if(!superAdminInfo.allTests && superAdminInfo.allTests.length===1){
      setToastType(["warning", t("superAdmin.results.compareTab.error_notEnoughTest")])
      setToastOpen(true)
      return
    }

    if(!(testId[0]) || !(testId[1])) {
      setToastType(["warning", t("commonItems.error_requiredFields")])
      setToastOpen(true)
      return
    }

    const testId1 = String(testId[0])
    const testId2 = String(testId[1])

    let oldTestIds = Object.keys(reportData)
    let newTestIds = []

    if(!oldTestIds.includes(testId1)) newTestIds.push(testId1)
    if(!oldTestIds.includes(testId2)) newTestIds.push(testId2)

    // console.log(oldTestIds)
    // console.log(testId1, testId2)
    // console.log(newTestIds)

    setReportError("")
    if(newTestIds.length){
      setReportState(true)
      const superAdminId = superAdminInfo.superAdmin.superAdminId
      Auth.currentSession()
      .then(async (data) => {
        const jwtToken = data.idToken.jwtToken;
  
        try {
          const response =  await axios.get("https://zk1128nq2f.execute-api.ap-south-1.amazonaws.com/alpha/superAdmin/"+superAdminId+"/compare-result?testId="+testId.toString()+"&allRegions=1&ver=2", {
          // const response =  await axios.get("https://zk1128nq2f.execute-api.ap-south-1.amazonaws.com/alpha/superAdmin/"+superAdminId+"/compare-result?testId="+testId.toString()+"&region=MUMBAI", {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': jwtToken
            }
          });
          // console.log("get Response: ",response.data)
          // Remove keys from the metric object
          // let metricFilters = []
          let metricFilters = ["pace", "accuracy"]
          let filteredMetric = Object.fromEntries(
              Object.entries(response.data.report.metric).map(([metricLang, metrics]) => {
                  let filtered = Object.fromEntries(
                      Object.entries(metrics).filter(([key]) => !metricFilters.includes(key))
                    );
                    return [metricLang, filtered];
                  })
                );
          const responseData = {...response.data["report"],
            "metric": filteredMetric
          }
          setReportData({...responseData})
          let selectedTestLangs = superAdminInfo.allTests.filter(item => item.testId === testId[0])[0].lang.filter(lan => 
            superAdminInfo.allTests.filter(item => item.testId === testId[1])[0].lang.includes(lan)
          )
          let selectedLang = selectedTestLangs.sort()[0]
          if(!selectedTestLangs.includes(lang)) setLang(selectedLang)
          setStd([...new Set(responseData[testId[0]].report.allRegions[selectedLang].map(item => item.std))].filter(item => 
            [...new Set(responseData[testId[1]].report.allRegions[selectedLang].map(item => item.std))].includes(item)
          ).sort((a, b) => a - b)[0])
          let metric = Object.keys(responseData.metric[selectedLang])[0]
          setMetric(metric)
          // setChartType(responseData.metric[selectedLang][metric][0])
          setRegion("OVERALL");
          setReportState(false)
          setCompareState(false)
        }
        catch (error) {
          // console.log(error)
          if(error.response.status === 404) setReportError(t("superAdmin.results.compareTab.error_api_resultNotFound"))
          else{
            console.log(error)
            setToastType(["error", t("commonItems.error_api_generic")])
            setToastOpen(true)
          }
          setReportState(false)
        }
      })
      .catch((err) => console.log(err));
    }
    else setCompareState(false)
  }

  return (
    <>
      <Snackbar open={toastOpen} autoHideDuration={5000} onClose={handleToastClose}>
        <Alert onClose={handleToastClose} severity={toastType[0]} sx={{ width: '100%' }}>
        {toastType[1]}
        </Alert>
      </Snackbar>
      <div className="filters" style={{flexDirection: "column", alignItems: "unset"}}>
        <div className="forms">
          <FormControl sx={{ m: 1, minWidth: 150}} size="small">
            <InputLabel id="test1FilterLabel">{t("superAdmin.results.compareTab.dropdownLabel_test1")}</InputLabel>
            <Select
              labelId="test1FilterLabel"
              id="test1Filter"
              value={testId[0] ? testId[0] : ""}
              onChange={(e) => handleTestIdChange(0, e.target.value)}
              autoWidth
              label={t("superAdmin.results.compareTab.dropdownLabel_test1")}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {/* getting all unique std values from data */}
              {superAdminInfo.allTests &&
                superAdminInfo.allTests.filter(item => item.status === 3).map(item => item.testName).map((item, i) => {
                return <MenuItem key={i} value={superAdminInfo.allTests[i].testId} disabled={testId[1] === superAdminInfo.allTests[i].testId}>{item}</MenuItem>
                })
              }
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: 150}} size="small">
            <InputLabel id="test2FilterLabel">{t("superAdmin.results.compareTab.dropdownLabel_test2")}</InputLabel>
            <Select
              labelId="test2FilterLabel"
              id="test2Filter"
              value={testId[1] ? testId[1] : ""}
              onChange={(e) => handleTestIdChange(1, e.target.value)}
              autoWidth
              label={t("superAdmin.results.compareTab.dropdownLabel_test2")}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {/* getting all unique std values from data */}
              {superAdminInfo.allTests &&
                superAdminInfo.allTests.filter(item => item.status === 3).map(item => item.testName).map((item, i) => {
                return <MenuItem key={i} value={superAdminInfo.allTests[i].testId} disabled={testId[0] === superAdminInfo.allTests[i].testId}>{item}</MenuItem>
                })
              }
            </Select>
          </FormControl>
          {reportState 
            ?
            <Button color="info" variant="contained" disabled sx={{m: 1}}>{t("superAdmin.results.compareTab.buttonLabel_compare")}<CircularProgress size="1rem" color="inherit" sx={{marginLeft: "0.25rem"}}/></Button>
            :
            <Button color="info" variant="contained" onClick={handleCompare} sx={{m: 1}}>{t("superAdmin.results.compareTab.buttonLabel_compare")}</Button>
          }
        </div>
        {!compareState ?
          <div className="forms">
            <h4 style={{display: "flex", justifyContent: "center", alignItems: "center", gap: "0.25rem"}}>
              <FilterListIcon fontSize="small"/>
              <span style={{height: "100%"}}>{t("commonItems.filterLabel")}</span> 
            </h4>
            <FormControl sx={{ m: 1, minWidth: 150}} size="small">
              <InputLabel id="langFilterLabel">{t("commonItems.dropdownLabel_lang")}</InputLabel>
              <Select
                labelId="langFilterLabel"
                id="langFilter"
                value={lang}
                onChange={handleLangChange}
                autoWidth
                label={t("commonItems.dropdownLabel_lang")}
              >
                { superAdminInfo.allTests &&
                  superAdminInfo.allTests.filter(item => item.testId === testId[0])[0].lang.filter(lan => 
                    superAdminInfo.allTests.filter(item => item.testId === testId[1])[0].lang.includes(lan)
                  ).sort().map((item, i) => {
                    return <MenuItem key={i} value={item}>{superAdminInfo.allLangs[item]}</MenuItem>
                  })
                }
              </Select>
            </FormControl>
            <FormControl sx={{ m: 1, minWidth: 120}} size="small">
              <InputLabel id="metricFilterLabel">{t("commonItems.dropdownLabel_metric")}</InputLabel>
              <Select
                labelId="metricFilterLabel"
                id="metricFilter"
                value={metric}
                onChange={handleMetricChange}
                autoWidth
                label={t("commonItems.dropdownLabel_metric")}
              >
                { reportData!=="" && lang &&
                  Object.keys(reportData["metric"][lang]).map((item, i) => {
                    return <MenuItem key={i} value={item}>{
                      item==="wcpm" ? "WCPM" : 
                      item==="phrasing" ? "Phrasing" : 
                      item==="pace" ? "Pace" :
                      item==="accuracy" ? "Accuracy" :
                      item 
                    }</MenuItem>
                  })
                }
              </Select>
            </FormControl>
            <FormControl sx={{ m: 1, minWidth: 85}} size="small">
              <InputLabel id="stdFilterLabel">{t("commonItems.dropdownLabel_class")}</InputLabel>
              <Select
                labelId="stdFilterLabel"
                id="stdFilter"
                value={std}
                onChange={handleStdChange}
                autoWidth
                label={t("commonItems.dropdownLabel_class")}
              >
                {/* <MenuItem value="">
                  <em>None</em>
                </MenuItem> */}
                {/* getting all unique std values from data */}
                { Object.keys(reportData).length && lang &&
                  [...new Set(reportData[testId[0]].report.allRegions[lang].map(item => item.std))].filter(item => 
                    [...new Set(reportData[testId[1]].report.allRegions[lang].map(item => item.std))].includes(item)
                  ).sort((a, b) => a - b).map((item, i) => {
                  return <MenuItem key={i} value={item}>{item}</MenuItem>
                  })
                }
              </Select>
            </FormControl>
            <FormControl sx={{ m: 1, minWidth: 150}} size="small">
              <InputLabel id="regionFilterLabel">{t("commonItems.dropdownLabel_region")}</InputLabel>
              <Select
                labelId="regionFilterLabel"
                id="regionFilter"
                value={region}
                onChange={handleRegionChange}
                autoWidth
                label={t("commonItems.dropdownLabel_region")}
              >
                {/* <MenuItem value="">
                  <em>None</em>
                </MenuItem> */}
                <MenuItem value="OVERALL">OVERALL</MenuItem>
                {/* getting all unique region values from data */}
                { Object.keys(reportData).length && lang &&
                  [...new Set(reportData[testId[0]].report.allRegions[lang].map(item => item.region))].filter(item => 
                    [...new Set(reportData[testId[1]].report.allRegions[lang].map(item => item.region))].includes(item)
                  ).sort().map((item, i) => {
                  return <MenuItem key={i} value={item}>{item}</MenuItem>
                  })
                }
              </Select>
            </FormControl>
          </div>
        :
          <MuiAlert severity="info" className="uploadInstructions" style={{marginTop: "0.5rem"}}>
            <AlertTitle><b>{t("superAdmin.results.compareTab.noTestSelectedInfo")}</b></AlertTitle>
          </MuiAlert>
        }
      </div>
      <div className="charts">
        {!reportError ? 
          <>
            {filteredReportData && lang && !compareState &&
              <>
                {metric === "wcpm" &&
                  <BarChart
                    chartData = {[filteredReportData[testId[0]].allRegions.reduce((acc, item) => {
                        return [ acc[0] + item.wcpmCat1, acc[1] + item.wcpmCat2, acc[2] + item.wcpmCat3, acc[3] + item.wcpmCat4, acc[4] + item.wcpmCat5, acc[5] + item.wcpmTotal ]
                      }, [0, 0, 0, 0, 0, 0])].concat(
                        [...new Set(filteredReportData[testId[0]].allRegions.map((item) => item.region))]
                          .filter(r => {
                            // return region==="" ? true 
                            // : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                            // : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                            // : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                            // : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                            // : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                            // : region === r
                            return region === r
                          })
                          .map(region => filteredReportData[testId[0]].allRegions.filter(item=> item.region === region)
                          .reduce((acc, item) => {
                              return [ acc[0] + item.wcpmCat1, acc[1] + item.wcpmCat2, acc[2] + item.wcpmCat3, acc[3] + item.wcpmCat4, acc[4] + item.wcpmCat5, acc[5] + item.wcpmTotal ]
                          }, [0, 0, 0, 0, 0, 0]))
                        ).concat(
                        [filteredReportData[testId[1]].allRegions.reduce((acc, item) => {
                          return [ acc[0] + item.wcpmCat1, acc[1] + item.wcpmCat2, acc[2] + item.wcpmCat3, acc[3] + item.wcpmCat4, acc[4] + item.wcpmCat5, acc[5] + item.wcpmTotal ]
                        }, [0, 0, 0, 0, 0, 0])].concat(
                          [...new Set(filteredReportData[testId[1]].allRegions.map((item) => item.region))]
                            .filter(r => {
                              // return region==="" ? true 
                              // : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                              // : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                              // : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                              // : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                              // : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                              // : region === r
                              return region === r
                            })
                            .map(region => filteredReportData[testId[1]].allRegions.filter(item=> item.region === region)
                            .reduce((acc, item) => {
                              return [ acc[0] + item.wcpmCat1, acc[1] + item.wcpmCat2, acc[2] + item.wcpmCat3, acc[3] + item.wcpmCat4, acc[4] + item.wcpmCat5, acc[5] + item.wcpmTotal ]
                            }, [0, 0, 0, 0, 0, 0]))
                          ))
                    }
                    labelData = {["OVERALL - " + superAdminInfo.allTests.filter(item => item.testId === testId[0])[0].testName].concat( 
                        [...new Set(filteredReportData[testId[0]].allRegions.map((item) => item.region))]
                          .filter(r => {
                            // return region==="" ? true 
                            //   : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                            //   : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                            //   : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                            //   : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                            //   : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                            //   : region === r
                            return region === r
                          }).map(r => r + " - " + superAdminInfo.allTests.filter(item => item.testId === testId[0])[0].testName)
                      ).concat(
                        ["OVERALL - " + superAdminInfo.allTests.filter(item => item.testId === testId[1])[0].testName].concat( 
                          [...new Set(filteredReportData[testId[1]].allRegions.map((item) => item.region))]
                            .filter(r => {
                              // return region==="" ? true 
                              //   : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                              //   : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                              //   : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                              //   : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                              //   : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                              //   : region === r
                              return region === r
                            }).map(r => r + " - " + superAdminInfo.allTests.filter(item => item.testId === testId[1])[0].testName)
                        )
                      )
                    }
                    catLabelData={
                      [
                        filteredReportData[testId[0]].thresholds.wcpmT1 < 0 ? "Invalid Entries" : t("commonItems.chartCatLabel_bar_wcpm1", {t1: 0, t2: filteredReportData[testId[0]].thresholds.wcpmT1}),
                        t("commonItems.chartCatLabel_bar_wcpm1", {t1: filteredReportData[testId[0]].thresholds.wcpmT1+1, t2: filteredReportData[testId[0]].thresholds.wcpmT2}),
                        t("commonItems.chartCatLabel_bar_wcpm1", {t1: filteredReportData[testId[0]].thresholds.wcpmT2+1, t2: filteredReportData[testId[0]].thresholds.wcpmT3}),
                        filteredReportData[testId[0]].thresholds.wcpmT4 < 0 ?  t("commonItems.chartCatLabel_bar_wcpm2", {t1: filteredReportData[testId[0]].thresholds.wcpmT3+1}) : t("commonItems.chartCatLabel_bar_wcpm1", {t1: filteredReportData[testId[0]].thresholds.wcpmT3+1, t2: filteredReportData[testId[0]].thresholds.wcpmT4}),
                        filteredReportData[testId[0]].thresholds.wcpmT4 < 0 ? "-" : t("commonItems.chartCatLabel_bar_wcpm2", {t1: filteredReportData[testId[0]].thresholds.wcpmT4+1})
                      ]
                    }
                    title = {"WCPM - " + t("superAdmin.results.compareTab.chartTitle") + " - " + superAdminInfo.allLangs[lang]}
                    xLabel = {t("superAdmin.results.compareTab.chartXLabel") + " - " + region}
                    yLabel = {t("superAdmin.results.compareTab.chartYLabel", {unit: "%"})}
                    chartName={region}
                  />
                }
                { metric === "phrasing" &&
                  <>
                    {Object.keys(filteredReportData[testId[0]].thresholds).includes("phrasingT1") ?
                      <BarChart
                        chartData = {[filteredReportData[testId[0]].allRegions.reduce((acc, item) => {
                              return [ acc[0] + item.phrasingNotQualified, acc[1] + item.phrasingCat1, acc[2] + item.phrasingCat2, acc[3] + item.phrasingCat3, acc[4] + item.phrasingCat4, acc[5] + item.phrasingTotal ]
                          }, [0, 0, 0, 0, 0, 0])].concat(
                            [...new Set(filteredReportData[testId[0]].allRegions.map((item) => item.region))]
                              .filter(r => {
                                // return region==="" ? true 
                                // : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                                // : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                                // : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                                // : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                                // : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                                // : region === r
                                return region === r
                              })
                              .map(region => filteredReportData[testId[0]].allRegions.filter(item=> item.region === region)
                              .reduce((acc, item) => {
                                return [ acc[0] + item.phrasingNotQualified, acc[1] + item.phrasingCat1, acc[2] + item.phrasingCat2, acc[3] + item.phrasingCat3, acc[4] + item.phrasingCat4, acc[5] + item.phrasingTotal ]
                              }, [0, 0, 0, 0, 0, 0]))
                            ).concat(
                            [filteredReportData[testId[1]].allRegions.reduce((acc, item) => {
                              return [ acc[0] + item.phrasingNotQualified, acc[1] + item.phrasingCat1, acc[2] + item.phrasingCat2, acc[3] + item.phrasingCat3, acc[4] + item.phrasingCat4, acc[5] + item.phrasingTotal ]
                            }, [0, 0, 0, 0, 0, 0])].concat(
                              [...new Set(filteredReportData[testId[1]].allRegions.map((item) => item.region))]
                                .filter(r => {
                                  // return region==="" ? true 
                                  // : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                                  // : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                                  // : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                                  // : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                                  // : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                                  // : region === r
                                  return region === r
                                })
                                .map(region => filteredReportData[testId[1]].allRegions.filter(item=> item.region === region)
                                .reduce((acc, item) => {
                                  return [ acc[0] + item.phrasingNotQualified, acc[1] + item.phrasingCat1, acc[2] + item.phrasingCat2, acc[3] + item.phrasingCat3, acc[4] + item.phrasingCat4, acc[5] + item.phrasingTotal ]
                                }, [0, 0, 0, 0, 0, 0]))
                              ))
                        }
                        labelData = {["OVERALL - " + superAdminInfo.allTests.filter(item => item.testId === testId[0])[0].testName].concat( 
                            [...new Set(filteredReportData[testId[0]].allRegions.map((item) => item.region))]
                              .filter(r => {
                                // return region==="" ? true 
                                //   : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                                //   : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                                //   : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                                //   : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                                //   : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                                //   : region === r
                                return region === r
                              }).map(r => r + " - " + superAdminInfo.allTests.filter(item => item.testId === testId[0])[0].testName)
                          ).concat(
                            ["OVERALL - " + superAdminInfo.allTests.filter(item => item.testId === testId[1])[0].testName].concat( 
                              [...new Set(filteredReportData[testId[1]].allRegions.map((item) => item.region))]
                                .filter(r => {
                                  // return region==="" ? true 
                                  //   : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                                  //   : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                                  //   : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                                  //   : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                                  //   : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                                  //   : region === r
                                  return region === r
                                }).map(r => r + " - " + superAdminInfo.allTests.filter(item => item.testId === testId[1])[0].testName)
                            )
                          )
                        }
                        catLabelData={
                            [
                              // "Phrasing > " + filteredReportData.thresholds.enPhrasingScoreT1,
                              // "Phrasing between " + (filteredReportData.thresholds.enPhrasingScoreT2) + " - " + filteredReportData.thresholds.enPhrasingScoreT1,
                              // "Phrasing between 0 - " + filteredReportData.thresholds.enPhrasingScoreT2
                              t("commonItems.chartCatLabel_bar_phrasing1"), 
                              t("commonItems.chartCatLabel_bar_phrasing2"), 
                              t("commonItems.chartCatLabel_bar_phrasing3"), 
                              t("commonItems.chartCatLabel_bar_phrasing4"), 
                              t("commonItems.chartCatLabel_bar_phrasing5")
                            ]
                        }
                        title = {"Phrasing - " + t("superAdmin.results.compareTab.chartTitle") + " - " + superAdminInfo.allLangs[lang]}
                        xLabel = {t("superAdmin.results.compareTab.chartXLabel") + " - " + region}
                        yLabel = {t("superAdmin.results.compareTab.chartYLabel", {unit: "%"})}
                        chartName={region}
                        // chartColors={["#FFB5B5", "#E8CFFA", "#8CCDFF", "#AAEACB"]}
                      />
                    :
                      <h3 style={{placeSelf: "center"}}>{t("commonItems.error_metricNotFound", {metric: "Phrasing"})}</h3>
                    }
                  </>
                }
                {metric === "pace" &&
                  <>
                    {Object.keys(filteredReportData[testId[0]].thresholds).includes("paceT1") ?
                      <BarChart
                        chartData = {[filteredReportData[testId[0]].allRegions.reduce((acc, item) => {
                          return [ acc[0] + item.paceCat1, acc[1] + item.paceCat2, acc[2] + item.paceCat3, acc[3] + item.paceCat4, acc[4] + item.paceTotal ]
                          }, [0, 0, 0, 0, 0])].concat(
                            [...new Set(filteredReportData[testId[0]].allRegions.map((item) => item.region))]
                              .filter(r => {
                                // return region==="" ? true 
                                // : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                                // : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                                // : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                                // : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                                // : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                                // : region === r
                                return region === r
                              })
                              .map(region => filteredReportData[testId[0]].allRegions.filter(item=> item.region === region)
                              .reduce((acc, item) => {
                                  return [ acc[0] + item.paceCat1, acc[1] + item.paceCat2, acc[2] + item.paceCat3, acc[3] + item.paceCat4, acc[4] + item.paceTotal ]
                              }, [0, 0, 0, 0, 0]))
                            ).concat(
                            [filteredReportData[testId[1]].allRegions.reduce((acc, item) => {
                              return [ acc[0] + item.paceCat1, acc[1] + item.paceCat2, acc[2] + item.paceCat3, acc[3] + item.paceCat4, acc[4] + item.paceTotal ]
                            }, [0, 0, 0, 0, 0])].concat(
                              [...new Set(filteredReportData[testId[1]].allRegions.map((item) => item.region))]
                                .filter(r => {
                                  // return region==="" ? true 
                                  // : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                                  // : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                                  // : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                                  // : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                                  // : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                                  // : region === r
                                  return region === r
                                })
                                .map(region => filteredReportData[testId[1]].allRegions.filter(item=> item.region === region)
                                .reduce((acc, item) => {
                                  return [ acc[0] + item.paceCat1, acc[1] + item.paceCat2, acc[2] + item.paceCat3, acc[3] + item.paceCat4, acc[4] + item.paceTotal ]
                                }, [0, 0, 0, 0, 0]))
                              ))
                        }
                        labelData = {["OVERALL - " + superAdminInfo.allTests.filter(item => item.testId === testId[0])[0].testName].concat( 
                            [...new Set(filteredReportData[testId[0]].allRegions.map((item) => item.region))]
                              .filter(r => {
                                // return region==="" ? true 
                                //   : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                                //   : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                                //   : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                                //   : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                                //   : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                                //   : region === r
                                return region === r
                              }).map(r => r + " - " + superAdminInfo.allTests.filter(item => item.testId === testId[0])[0].testName)
                          ).concat(
                            ["OVERALL - " + superAdminInfo.allTests.filter(item => item.testId === testId[1])[0].testName].concat( 
                              [...new Set(filteredReportData[testId[1]].allRegions.map((item) => item.region))]
                                .filter(r => {
                                  // return region==="" ? true 
                                  //   : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                                  //   : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                                  //   : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                                  //   : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                                  //   : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                                  //   : region === r
                                  return region === r
                                }).map(r => r + " - " + superAdminInfo.allTests.filter(item => item.testId === testId[1])[0].testName)
                            )
                          )
                        }
                        catLabelData={
                          [
                            // "Slow", "Medium", "Fast", "Very Fast"
                            t("commonItems.chartCatLabel_bar_pace1", {t1: (parseFloat(filteredReportData[testId[0]].thresholds.paceT1) + 0.1).toFixed(1)}),
                            t("commonItems.chartCatLabel_bar_pace2", {t1: (parseFloat(filteredReportData[testId[0]].thresholds.paceT1) + 0.1).toFixed(1), t2: (parseFloat(filteredReportData[testId[0]].thresholds.paceT2) + 0.1).toFixed(1)}),
                            t("commonItems.chartCatLabel_bar_pace3", {t1: (parseFloat(filteredReportData[testId[0]].thresholds.paceT2) + 0.1).toFixed(1), t2: (parseFloat(filteredReportData[testId[0]].thresholds.paceT3) + 0.1).toFixed(1)}),
                            t("commonItems.chartCatLabel_bar_pace4", {t1: (parseFloat(filteredReportData[testId[0]].thresholds.paceT3) + 0.1).toFixed(1)})
                          ]
                        }
                        title = {"Pace - " + t("superAdmin.results.compareTab.chartTitle") + " - " + superAdminInfo.allLangs[lang]}
                        xLabel = {t("superAdmin.results.compareTab.chartXLabel") + " - " + region}
                        yLabel = {t("superAdmin.results.compareTab.chartYLabel", {unit: "%"})}
                        chartName={region}
                      />
                    :
                      <h3 style={{placeSelf: "center"}}>{t("commonItems.error_metricNotFound", {metric: "Pace"})}</h3>
                    }
                  </>
                }
                {metric === "accuracy" &&
                  <>
                    {Object.keys(filteredReportData[testId[0]].thresholds).includes("accuracyT1") ?
                      <BarChart
                        chartData = {[filteredReportData[testId[0]].allRegions.reduce((acc, item) => {
                          return [ acc[0] + item.accuracyCat1, acc[1] + item.accuracyCat2, acc[2] + item.accuracyCat3, acc[3] + item.accuracyCat4, acc[4] + item.accuracyTotal ]
                          }, [0, 0, 0, 0, 0])].concat(
                            [...new Set(filteredReportData[testId[0]].allRegions.map((item) => item.region))]
                              .filter(r => {
                                // return region==="" ? true 
                                // : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                                // : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                                // : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                                // : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                                // : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                                // : region === r
                                return region === r
                              })
                              .map(region => filteredReportData[testId[0]].allRegions.filter(item=> item.region === region)
                              .reduce((acc, item) => {
                                  return [ acc[0] + item.accuracyCat1, acc[1] + item.accuracyCat2, acc[2] + item.accuracyCat3, acc[3] + item.accuracyCat4, acc[4] + item.accuracyTotal ]
                              }, [0, 0, 0, 0, 0]))
                            ).concat(
                            [filteredReportData[testId[1]].allRegions.reduce((acc, item) => {
                              return [ acc[0] + item.accuracyCat1, acc[1] + item.accuracyCat2, acc[2] + item.accuracyCat3, acc[3] + item.accuracyCat4, acc[4] + item.accuracyTotal ]
                            }, [0, 0, 0, 0, 0])].concat(
                              [...new Set(filteredReportData[testId[1]].allRegions.map((item) => item.region))]
                                .filter(r => {
                                  // return region==="" ? true 
                                  // : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                                  // : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                                  // : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                                  // : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                                  // : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                                  // : region === r
                                  return region === r
                                })
                                .map(region => filteredReportData[testId[1]].allRegions.filter(item=> item.region === region)
                                .reduce((acc, item) => {
                                  return [ acc[0] + item.accuracyCat1, acc[1] + item.accuracyCat2, acc[2] + item.accuracyCat3, acc[3] + item.accuracyCat4, acc[4] + item.accuracyTotal ]
                                }, [0, 0, 0, 0, 0]))
                              ))
                        }
                        labelData = {["OVERALL - " + superAdminInfo.allTests.filter(item => item.testId === testId[0])[0].testName].concat( 
                            [...new Set(filteredReportData[testId[0]].allRegions.map((item) => item.region))]
                              .filter(r => {
                                // return region==="" ? true 
                                //   : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                                //   : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                                //   : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                                //   : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                                //   : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                                //   : region === r
                                return region === r
                              }).map(r => r + " - " + superAdminInfo.allTests.filter(item => item.testId === testId[0])[0].testName)
                          ).concat(
                            ["OVERALL - " + superAdminInfo.allTests.filter(item => item.testId === testId[1])[0].testName].concat( 
                              [...new Set(filteredReportData[testId[1]].allRegions.map((item) => item.region))]
                                .filter(r => {
                                  // return region==="" ? true 
                                  //   : region === "ZIET BHUBANESWAR" ? ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"].includes(r)
                                  //   : region === "ZIET CHANDIGARH" ? ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"].includes(r) 
                                  //   : region === "ZIET GWALIOR" ? ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"].includes(r)
                                  //   : region === "ZIET MUMBAI" ? ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"].includes(r)
                                  //   : region === "ZIET MYSORE" ? ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"].includes(r)
                                  //   : region === r
                                  return region === r
                                }).map(r => r + " - " + superAdminInfo.allTests.filter(item => item.testId === testId[1])[0].testName)
                            )
                          )
                        }
                        catLabelData={
                          [
                            // "Poor", "Fair", "Good", "Excellent"
                            t("commonItems.chartCatLabel_bar_accuracy1", {t1: (filteredReportData[testId[0]].thresholds.accuracyT1+1)}),
                            t("commonItems.chartCatLabel_bar_accuracy2", {t1: (filteredReportData[testId[0]].thresholds.accuracyT1+1), t2: (filteredReportData[testId[0]].thresholds.accuracyT2+1)}),
                            t("commonItems.chartCatLabel_bar_accuracy3", {t1: (filteredReportData[testId[0]].thresholds.accuracyT2+1), t2: (filteredReportData[testId[0]].thresholds.accuracyT3+1)}),
                            t("commonItems.chartCatLabel_bar_accuracy4", {t1: (filteredReportData[testId[0]].thresholds.accuracyT3+1)})
                          ]
                        }
                        title = {"Accuracy - " + t("superAdmin.results.compareTab.chartTitle") + " - " + superAdminInfo.allLangs[lang]}
                        xLabel = {t("superAdmin.results.compareTab.chartXLabel") + " - " + region}
                        yLabel = {t("superAdmin.results.compareTab.chartYLabel", {unit: "%"})}
                        chartName={region}
                      />
                    :
                      <h3 style={{placeSelf: "center"}}>{t("commonItems.error_metricNotFound", {metric: "Accuracy"})}</h3>
                    }
                  </>
                }
              </>
            }
            {reportState && compareState && <CircularProgress color="info" sx={{placeSelf: "center"}}/> }
          </>
        : <h3 style={{placeSelf: "center"}}>{reportError}</h3>
      }
      </div>
    </>
  )
}

export default CompareReport